module.exports = __webpack_public_path__ + "img/about1.5456b0f9.png";